export class CustomerVenueGroup {
	pk: string; //:venueKey
	sk: string; //uuid
	name: string;
	description: string;
	created: string;

	lastCountResult: number;
	lastCountDateTime: string;

	type: number;
	criteria: number;
	operator: number;
	value: number;
	value2: number;

	customerKeyList: string[];
	adhocEmailAddressList: string[];

	design: string;

	public constructor(init?: Partial<CustomerVenueGroup>) {
		Object.assign(this, init);
	}
}

export enum CustomerVenueGroupType {
	DYNAMIC = 1,
	STATIC = 2,
	ALL = 3,
}
